import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { LeftOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Button, Card, Input, message } from 'antd';
import encrypt from "@/tools/encrypt";
import { newPasswordCheck, validPassword } from '../validator';
import { unifiedPassword, removeLoginData } from '../utils';
import { getSessionObject } from '@/tools/utils'
import './login-unify.less';

const BackBtn = () => {
    const history = useHistory();

    return (
        <span className='back-btn' onClick={() => {
            // 清空loginData
            removeLoginData();
            history.goBack();
        }}>
            <LeftOutlined className='backSvg' />
            <span className='backText'>返回</span>
        </span>
    );
};

const layout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 }
};
const tailLayout = {
    wrapperCol: { offset: 0, span: 24 }
};


const LoginUnify = (props) => {
    const { form } = props;
    const history = useHistory();
    const [ loginData, setLoginData ] = useState({});
    const [ btnLoading, setBtnLoading ] = useState(false);

    // 检查是否允许进入该页面,初始化数据
    useEffect(() => {
        const loginData = getSessionObject('loginData') || {};
        if (
            Object.keys(loginData).length <= 0 ||
            !loginData.needUnifiedPwd
        ) {
            history.replace('/login');
        }
        setLoginData(loginData);
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        form.validateFields(async (err, values) => {
            if (!err) {
                try {
                    setBtnLoading(true);
                    const params = {
                        ...loginData.params,
                        newPassword: encrypt(values.newPassword)
                    };
                    // 统一密码，统一后重新清除loginData，重新登录
                    const res = await unifiedPassword(params, loginData.loginType);
                    if (res.status === 200) {
                        message.success('修改成功');
                        removeLoginData();
                        history.replace('/login');
                    }
                } finally {
                    setBtnLoading(false);
                }
            }
        })
    };
    return (
        <div className='unify-card-container' style={{paddingRight: '36px'}}>
            <Card className='unify-card' title={<BackBtn/>}>
                <div className='head'>
                    <h2 className='head-title'>统一身份认证</h2>
                    <p className='head-desc'>系统检测到您的账号已关联了多个商户，请统一设置新密码，后续使用该账号密码即可管理多个商户</p>
                </div>
                <div className='form'>
                    <Form
                        {...layout}
                        onSubmit={handleSubmit}
                    >
                        <Form.Item>
                            {
                                form.getFieldDecorator('newPassword', {
                                    validateTrigger: 'onBlur',
                                    validateFirst: true,
                                    rules: [
                                        {
                                            required: true,
                                            message: '请设置新密码'
                                        },
                                        newPasswordCheck(),
                                        {
                                            validator(_, value) {
                                                if (value && form.getFieldValue('replicaPassword')) {
                                                    form.validateFields(['replicaPassword']);
                                                }
                                                return Promise.resolve();
                                            },
                                        }
                                    ],
                                })(
                                    <Input.Password
                                        size="large"
                                        maxLength={20}
                                        placeholder="设置新密码（6-20位，包含字母和数字）"
                                        visibilityToggle={Boolean(form.getFieldValue('newPassword'))}
                                        allowClear
                                    />
                                )
                            }
                        </Form.Item>

                        <Form.Item>
                            {
                                form.getFieldDecorator('replicaPassword', {
                                    validateFirst: true,
                                    validateTrigger: 'onBlur',
                                    rules: [
                                        {
                                            required: true,
                                            message: '请确认新密码'
                                        },
                                        validPassword(),
                                        {
                                            validator(_, value) {
                                                if (!value || form.getFieldValue('newPassword') === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('输入的两次密码不一致'));
                                            },
                                        },
                                    ],
                                })(
                                    <Input.Password
                                        size="large"
                                        maxLength={20}
                                        placeholder="确认新密码"
                                        visibilityToggle={Boolean(form.getFieldValue('replicaPassword'))}
                                        allowClear
                                    />
                                )
                            }
                        </Form.Item>
                        <Form.Item {...tailLayout} style={{marginBottom: 0}}>
                            <Button
                                loading={btnLoading}
                                type="primary"
                                size="large"
                                block
                                htmlType="submit"
                                className='submit-btn'
                            >
                                确认修改
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </Card>
        </div>
    );
};

const WrappedForm = Form.create()(LoginUnify);
export default WrappedForm;
